import React from 'react';
import SectionHeader from '../../Basic/SectionHeader';
import YesNoOptions from '../YesNoOptions';
import TextBox from '../../Basic/TextBox';
const Obstacles = () => {
    const lookup = window.osa.lookup.projectSpecifics.obstacles;
    return (
        <div>
            <SectionHeader title={lookup.title} />
            <YesNoOptions items={lookup.items} />
            <div  className="row">
                <div className="col-sm-2">Other</div>
                <div className="col-sm-3">
                    <TextBox name="OtherObstacle" />
                </div>
            </div>
        </div>
    );

};
export default Obstacles;